import { motion } from "framer-motion";
import { Zap, Leaf, Cog, Clock } from "lucide-react";
import { TID } from "@/lib/testIds";

const SERVICES = [
  {
    key: "power",
    icon: Zap,
    title: "Leistungssteigerung",
    desc: "Individuelle Optimierung von Leistung und Drehmoment — Stage 1 bis Stage 3, abgestimmt auf Ihr Fahrzeug.",
  },
  {
    key: "eco",
    icon: Leaf,
    title: "Eco-Tuning",
    desc: "Verbrauchsoptimierte Files für spürbar niedrigeren Verbrauch bei LKW, Agrar und LCVs.",
  },
  {
    key: "gearbox",
    icon: Cog,
    title: "Getriebe-Anpassung",
    desc: "Optimierte Schaltzeiten, angepasste Schaltpunkte und höhere Drehmoment-Freigaben für DSG & Wandler Automatik.",
  },
  {
    key: "support",
    icon: Clock,
    title: "24/7 Fileservice",
    desc: "Files rund um die Uhr über unser Portal anfordern — rasche & professionelle Bearbeitung.",
  },
];

export default function Services() {
  return (
    <section id="services-section" data-testid={TID.services.root} className="py-24 md:py-32 bg-[#070707] border-y border-white/10">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-3xl">
            <p className="text-sm uppercase tracking-[0.35em] text-primary mb-4">Leistungen</p>
            <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95] break-words">
              Engineering, das <span className="text-accent">liefert</span>{" "}
              <span className="block">– Für Privatkunden und Händler</span>
            </h2>
          </div>
          <p className="max-w-sm text-white/55 leading-relaxed text-sm md:text-base">
            Von der reinen Leistungssteigerung bis zur Effizienz-Optimierung — jedes File wird von Technikern erstellt und geprüft.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.key}
                data-testid={TID.services.card(s.key)}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="group relative bg-[#111] border border-white/10 p-8 hover:border-primary/40 hover:-translate-y-1 transition-[transform,border-color] duration-400"
              >
                <div className="h-12 w-12 grid place-items-center border border-accent/40 text-accent mb-8 group-hover:bg-accent group-hover:text-black transition-colors duration-300">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="font-display font-semibold uppercase tracking-tight text-xl md:text-2xl leading-tight break-words hyphens-auto text-white mb-3">
                  {s.title}
                </h3>
                <p className="text-sm text-white/55 leading-relaxed">{s.desc}</p>
                <div className="mt-6 h-px w-0 bg-primary group-hover:w-full transition-all duration-500" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
